import React from 'react';
import styles from './SafarMarketBanner.module.scss';
import Typography from '@/components/UI/typography/Typography';
const SafarMarketBanner = () => {
  return <Typography variant={'bodyM'} color={'neutral_min'} className={styles['container']} data-sentry-element="Typography" data-sentry-component="SafarMarketBanner" data-sentry-source-file="SafarMarketBanner.tsx">
      شما از موتور جستجوی{' '}
      <Typography variant={'bodyM'} className={styles['safarmarket-logo']} data-sentry-element="Typography" data-sentry-source-file="SafarMarketBanner.tsx">
        {' '}
        سفرمارکت{' '}
      </Typography>
      به شب هدایت شده اید
    </Typography>;
};
export default SafarMarketBanner;